import React from 'react';

const CastleIcon = (props) => {
  return (
    <img
      alt="Zamek"
      src="/static/images/icons/tourist_attractions/castle.svg"
      {...props}
    />
  );
};

export default CastleIcon;
